import React, { FC } from 'react'

import { PageContent } from 'common'
import { CustomBabi, ServiceCard, HelpCenterButton, MenuItemButton } from 'components'

import { HomeContainer, MenuContainer } from '../styles/styles'
import { THomeView } from '../types/Home.types'

export const HomeView: FC<THomeView> = ({
  menuSections,
  babiButton,
  faqCard,
  helpCenterButton,
  supportCard,
  showServiceMenu,
}) => (
  <PageContent>
    <HomeContainer>
      <MenuContainer>
        {menuSections.map(({ details, icon, title, onClick }) => (
          <MenuItemButton
            key={title}
            onClick={onClick}
            title={title}
            details={details}
            icon={icon}
          />
        ))}
      </MenuContainer>
      {!!faqCard?.isActive && <ServiceCard {...faqCard} />}
      {!!babiButton?.isActive && <CustomBabi />}
      {!!supportCard?.isActive && showServiceMenu && <ServiceCard {...supportCard} />}
      {!!helpCenterButton?.isActive && <HelpCenterButton {...helpCenterButton} />}
    </HomeContainer>
  </PageContent>
)
